import DashboardPage from "../page/DashboardPage/DashboardPgae";
import SingleSpendingDemandPage from "../page/SpendingDemand/SingleSpendingDemandPage/SingleSpendingDemandPage";
import SingleSpendingDemandUserPage from "../page/SpendingDemand/SingleSpendingDemandUserPage/SingleSpendingDemandUserPage";
import SpendingDemandPage from "../page/SpendingDemand/SpendingDemandPage/SpendingDemandPage";
import SingleTeamPage from "..//page/Team/SingleTeamPage/SingleTeamPage";
import TeamListPage from "../page/Team/TeamListPage/TeamListPage";
import CreateTeamPage from "../page/Team/CreateTeamPage/CreateTeamPage";
import UpdateTeamPage from "../page/Team/UpdateTeamPage/UpdateTeamPage";
import NewSpendingDemandPage from "../page/SpendingDemand/NewSpendingDemandPage/NewSpendingDemandPage";
import SpendingDemandUserListPage from "../page/SpendingDemand/SpendingDemandUserListPage/SpendingDemandUserListPage";
import UpdateSpendingDemandePage from "../page/SpendingDemand/UpdateSpendingDemandePage/UpdateSpendingDemandPage";
import ResetPasswordPage from "../page/ResetPassword/ResetPasswordPage/ResetPasswordPage";
import ResetPasswordrequestPage from "../page/ResetPassword/ResetPasswordrequestPage/ResetPasswordrequestPage";
import SentryTestPage from "../page/SentryTestPage/SentryTestPage";

export const homeRoutes = [
    {
      path: "/",
      name: "Dashboard",
      main: () => <DashboardPage/>,
      isInSideBar: true
    },
    {
      path: "/spending_demand",
      name: "Demande de Dépense",
      main: () => <SpendingDemandPage/>,
      isInSideBar: true
    },
    {
      path: "/spending_demand/:spendingDemandId",
      name: "detail",
      main: () => <SingleSpendingDemandPage/>,
    },
    {
      path: "/spending_demand_user/:spendingDemandId",
      name: "detail user",
      main: () => <SingleSpendingDemandUserPage/>,
    },

  
    {
      path: "teams",
      name: "Equipes",
      main: () => <TeamListPage/>,
      isInSideBar: true
    },
    {
      path: "teams/new",
      name: "Nouvelle équipes",
      main: () => <CreateTeamPage/>,
      isInSideBar: true
    },
  
    {
      path: "teams/:teamId",
      name: "Detail",
      main: () => <SingleTeamPage/>
    },
    {
      path: "/spending_demand/:teamId/edit",
      name: "detail",
      main: () => <UpdateTeamPage/>,
    },
    {
      path: "/spending_demand/new",
      name: "Nouvelle demande de dépense",
      main: () => <NewSpendingDemandPage/>,
    },
    {
      path: "/spending_demand_user",
      name: "Liste des demandes de dépense",
      main: () => <SpendingDemandUserListPage/>,
    },
    {
      path: "/spending_demand/:spendingDemandId/update",
      name: "Modification de la demande de dépense",
      main: () => <UpdateSpendingDemandePage/>,
    },
    {
      path: "/resetpwd",
      name: "Réinitialisation de mot de passe",
      main: () => <ResetPasswordPage/>,
    },
    {
      path: "/resetpwd/request",
      name: "Demande de réinitialisation de mot de passe",
      main: () => <ResetPasswordrequestPage/>,
    },
    // Page de test Sentry - seulement en développement
    ...(process.env.REACT_APP_MODE !== 'PROD' ? [{
      path: "/sentry-test",
      name: "Test Sentry",
      main: () => <SentryTestPage/>,
      isInSideBar: process.env.REACT_APP_MODE === 'DEV'
    }] : [])

  ];

  export default homeRoutes